import { render, staticRenderFns } from "./ActionPopup.vue?vue&type=template&id=f871b11c&scoped=true&"
import script from "./ActionPopup.vue?vue&type=script&lang=js&"
export * from "./ActionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f871b11c",
  null
  
)

export default component.exports